
import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook";
import MobileNavigation from "../../components/Navigation/MobileNavigation";
import LanguageSelector from "../../components/Navigation/LanguageSelector";
import { ReactComponent as HomeIcon } from "../../images/icons/HomeIcon.svg";
import { ReactComponent as LoginIcon } from "../../images/icons/LoginIcon.svg";
import { ReactComponent as SignInIcon } from "../../images/icons/SignInIcon.svg";
import logoGlobal from "../../images/logoGlobal.png";
import "./Navigation.css";

function GlobalNavigation({ onDesktopClick, isLoginOpen}) {
  const t = useTranslation();
console.log("isLoginOpen:", isLoginOpen);
  return (
    <nav className="navigation">
      <MobileNavigation t={t} menuItems={[ { label: t("aboutUs"), to: "/aboutus" }]}/>

      <div className="navigation__left">
        <NavLink to="/">  
          <img src={logoGlobal} className="navigation__logo" alt="Logo" />
        </NavLink>
      </div>      

      <ul className="navigation__menu">
        <li className="navigation__menu-list">
          <NavLink className="navigation__menu-item-guest" to="/courses"> {t("courses")} </NavLink>
        </li>
        <li className="navigation__menu-list">
          <NavLink className="navigation__menu-item-guest" to="/aboutus"> {t("aboutUs")} </NavLink>
        </li>
      </ul>

      <div className="navigation__actions">
        <div className="nav-icons">
          <NavLink to="/mycourses"><HomeIcon className="nav-icon"/></NavLink>
          <button className="icon-button" onClick={onDesktopClick}>
            {isLoginOpen ? <LoginIcon className="nav-icon"/> : <SignInIcon className="nav-icon"/>}
          </button>

          <LanguageSelector />

        </div>
      </div>
    </nav>
  );
}

export default GlobalNavigation;
